"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _Bytes = _interopRequireDefault(require("../primitive/Bytes"));

var _U = _interopRequireDefault(require("../primitive/U64"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name AccountInfo
 * @description
 * An Account information structure for contracts
 */
class AccountInfo extends _Struct.default {
  constructor(value) {
    super({
      trieId: _Bytes.default,
      currentMemStored: _U.default
    }, value);
  }
  /**
   * @description The size of stored value in octet
   */


  get currentMemStored() {
    return this.get('currentMemStored');
  }
  /**
   * @description Unique ID for the subtree encoded as a byte
   */


  get trieId() {
    return this.get('trieId');
  }

}

exports.default = AccountInfo;